"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");

var CleaningExportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CleaningExportDTO, _DomainObject_1$Domai);

  function CleaningExportDTO(productId, externalId, name, categoryPlan, category4box, family, supplier, flags, purchasePrice, prices, crps) {
    var _this;

    _classCallCheck(this, CleaningExportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CleaningExportDTO).call(this));
    _this.productId = productId;
    _this.externalId = externalId;
    _this.name = name;
    _this.categoryPlan = categoryPlan;
    _this.category4box = category4box;
    _this.family = family;
    _this.supplier = supplier;
    _this.flags = flags;
    _this.purchasePrice = purchasePrice;
    _this.prices = prices;
    _this.crps = crps;
    return _this;
  }

  return CleaningExportDTO;
}(DomainObject_1.DomainObject);

exports.CleaningExportDTO = CleaningExportDTO;